import { mapPreviewOpacity } from "../shared/mapPresentation";
import type { MapGeometry } from "../shared/types";
import { projectMapPoint, type VenueMapCamera } from "./venueMapProjection";
import {
  mapEntranceDotPoints,
  VENUE_MAP_ENTRANCE_DOT_COLOR,
} from "./venueMapEntranceDot";

/** Floor paint participates in perspective and sits behind booth geometry. */
export function VenueMapEntranceDots({
  camera,
  geometry,
}: {
  camera: VenueMapCamera;
  geometry: MapGeometry;
}) {
  return (
    <>
      {geometry.entrances.map((entrance) => (
        <polygon
          key={entrance.id}
          data-map-entrance-dot={entrance.id}
          opacity={mapPreviewOpacity(entrance)}
          points={mapEntranceDotPoints(entrance)
            .map((point) => {
              const projected = projectMapPoint(camera, {
                x: point.x / geometry.width,
                y: point.y / geometry.height,
                z: point.z,
              });
              return `${projected.x.toFixed(3)},${projected.y.toFixed(3)}`;
            })
            .join(" ")}
          fill={VENUE_MAP_ENTRANCE_DOT_COLOR}
        />
      ))}
    </>
  );
}

/** Upright entrance labels share the exact floor anchors used by the pins. */
export function VenueMapEntrances({
  camera,
  geometry,
}: {
  camera: VenueMapCamera;
  geometry: MapGeometry;
}) {
  const scale = camera.imageWidth / geometry.width;
  return (
    <>
      {geometry.entrances.map((entrance) => {
        const anchor = projectMapPoint(camera, {
          x: entrance.x / geometry.width,
          y: entrance.y / geometry.height,
        });
        return (
          <g
            key={entrance.id}
            data-map-entrance={entrance.id}
            opacity={mapPreviewOpacity(entrance)}
            transform={`translate(${anchor.x} ${anchor.y})`}
          >
            <text
              x={8 * scale}
              y={3 * scale}
              fill="#53665e"
              fontFamily="Inter, system-ui, sans-serif"
              fontSize={9.5 * scale}
              fontWeight="600"
              stroke="#f9f8f4"
              strokeWidth={3 * scale}
              strokeLinejoin="round"
              paintOrder="stroke"
            >
              {entrance.label}
            </text>
          </g>
        );
      })}
    </>
  );
}
